import { HttpGuardService } from 'src/app/guards/http-guard.service';
import { Injectable } from '@angular/core';
import { ApiConstants } from 'src/app/constants/api-constants';

@Injectable({
  providedIn: 'root'
})
export class AnalyticsServiceService {
  private selectedVehicles: any = {};
  chartList: any = [];

  constructor(private httpGuard: HttpGuardService) { }


  setSelectedVehicles(data: any): void {
    this.selectedVehicles = data;
  }

  getSelectedVehicles(): any {
    return this.selectedVehicles;
  }

  createReportRequest(payload: any) {
    return this.httpGuard.httpReq('post', 'API_ENDPOINT', ApiConstants.URL.reportRequests, payload);
  }

  createScheduledReport(payload: any) {
    return this.httpGuard.httpReq('post', 'API_ENDPOINT', ApiConstants.URL.scheduledReports, payload);
  }

  fetchReportRequest(pageNo: any, searchKey: any) {
    const params = searchKey ? '?scheduleId=null&page=' + pageNo + '&limit=10&searchKey=' + searchKey :
      '?scheduleId=null&page=' + pageNo + '&limit=10';
    return this.httpGuard.httpReq('get', 'API_ENDPOINT', ApiConstants.URL.reportRequests, params);

  }

  getScheduledReports(pageNo: number) {
    const params = '?purpose=%22list%22&nextRunTime=%22%22&page=' + pageNo + '&limit=10';
    return this.httpGuard.httpReq('get', 'API_ENDPOINT', ApiConstants.URL.scheduledReports, params);
  }

  enableReport(reportDetails: any) {
    const param = '/' + reportDetails?._id;
    const payload = {
      isActive: !JSON.parse(reportDetails?.isActive)
    };
    return this.httpGuard.httpReq('patch', 'API_ENDPOINT', `${ApiConstants.URL.scheduledReports}${param}`, payload);
  }

  deleteReport(reportList: string[]) {
    const deletePayload = {
      ids: reportList
    };
    return this.httpGuard.httpReq('post', 'API_ENDPOINT', ApiConstants.URL.deleteSchedule, deletePayload);
  }

  deleteManualReports(reportList: string[]) {
    const deletePayload = {
      ids: reportList
    };
    return this.httpGuard.httpReq('delete-post', 'API_ENDPOINT', ApiConstants.URL.reportRequests, deletePayload);
  }

  getGeneratedReport(pageNumber: number) {
    const params = '?page=' + pageNumber + '&limit=10&generatedBy=schedule';
    return this.httpGuard.httpReq('get', 'API_ENDPOINT', ApiConstants.URL.reportRequests, params);
  }

  updateScheduledReport(payload: any) {
    const param = '/' + payload?.job?.scheduleId;
    return this.httpGuard.httpReq('patch', 'API_ENDPOINT', `${ApiConstants.URL.scheduledReports}${param}`, payload);
  }

  quickShareReport(payload: any) {
    return this.httpGuard.httpReq('post', 'API_ENDPOINT', ApiConstants.URL.quickShareReport, payload);
  }

  getReportSummary(payload: any) {
    const param = '/' + payload?.reportId;
    return this.httpGuard.httpReq('get', 'API_ENDPOINT', `${ApiConstants.URL.reportSummary}${param}`);
  }

  getAttributeAggregateValue(payload: any) {
    return this.httpGuard.httpReq('post', 'API_ENDPOINT', ApiConstants.URL.attributeAggregateValue, payload);
  }

  getAnalyticsChartList() {
    return this.httpGuard.httpReq('get', 'API_ENDPOINT', ApiConstants.URL.analyticsChartV1);
  }

  createAnalyticsChart(payload: any) {
    return this.httpGuard.httpReq('post', 'API_ENDPOINT', ApiConstants.URL.analyticsChartV1, payload);
  }

  createSelfServiceChart(payload: any){
    return this.httpGuard.httpReq('post', 'API_ENDPOINT', ApiConstants.URL.selfServieChartV1, payload);
  }

  getSelfServiceCharts() {
    return this.httpGuard.httpReq('get', 'API_ENDPOINT', ApiConstants.URL.selfServieChartV1);
  }

  deleteSelfServiceChart(payload: any) {
    return this.httpGuard.httpReq('delete', 'API_ENDPOINT',  `${ApiConstants.URL.selfServieChartV1}/${payload?.chartId}`);
  }
  deleteChartLibrary(payload: any) {
    return this.httpGuard.httpReq('delete', 'API_ENDPOINT',  `${ApiConstants.URL.analyticsChartV1}/${payload}`);
  }
  setChartList(chart: any) {
    const index = this.chartList?.findIndex(item => item.order === chart?.order);

    if (index !== -1) {
      this.chartList[index] = chart;
    } else {
      this.chartList?.push(chart);
    }
  }
  getChartList() {
    return this.chartList;
  }
  removeChart(order: number) {
    this.chartList = this.chartList?.filter(item => item.order !== order);
  }
  updateSelfServiceChart(payload: any, id: string) {
    return this.httpGuard.httpReq('put', 'API_ENDPOINT', ApiConstants.URL.selfServieChartV1 + '/' + id, payload, true, 'response');
  }
}
